(function replaceTrademarks() {
  function replaceTextNodes(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      const original = node.textContent;
      if (!/LEGO|Minifigure/.test(original)) return;
      const updated = original
        .replace(/\bLEGO(?!®|™)/g, 'LEGO®')
        .replace(/\bMinifigure(?!®|™)\b/g, 'Minifigure®')
        .replace(/\bMinifigures(?!®|™)\b/g, 'Minifigures®');
      // Only touch the DOM when something actually changed; writing every text node forces a
      // full style/layout pass over the whole page.
      if (updated !== original) node.textContent = updated;
    } else if (
      node.nodeType === Node.ELEMENT_NODE &&
      !['SCRIPT', 'STYLE', 'TEXTAREA'].includes(node.tagName)
    ) {
      node.childNodes.forEach(replaceTextNodes);
    }
  }

  function initTrademarkFix() {
    replaceTextNodes(document.body);
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof runWhenIdle === 'function') {
      runWhenIdle(initTrademarkFix);
    } else {
      initTrademarkFix();
    }
  });
})();
